import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import { DipTag } from "../tag/dipTag";
import "./candidateThumbnail.css"
import { DisplayProfileImage } from "../image/displayProfileImage";
import { Avatar } from "primereact/avatar";
import { LikeEtudiant } from "../like/likeEtudiant";
import { ProjetOverlayPanel } from "../overlayPanel/projetOverlayPanel";
import RoleHelper from "../../utils/roleHelper";
import { useAuthState } from "../../context/context";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Tag } from "primereact/tag";
import { enumPaireContrat } from "../../enums/enumPaireContrat";
import { Fragment, useRef, useState } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import Helper from "../../utils/helper";
import DocumentService from "../../services/documentService";
import EntrepriseService from "../../services/entrepriseService";
import { Dialog } from "primereact/dialog";
import { UpgradeSubscriptionDialog } from "../dialog/upgradeSubscriptionDialog";
import { handleDocumentDownload } from "../../utils/handleDocumentDownload";
import { useCreditsContext } from "../../context/CreditsContext";
import { enumCreditableShareEntreprise } from "../../enums/enumCreditableShareEntreprise";
import { MissingCreditsDialog } from "../dialog/missingCreditsDialog";
import { IoCarOutline, IoCalendarOutline, IoSchoolOutline } from "react-icons/io5";

export const CandidateThumbnail = (props) => {

    const history = useHistory();
    const currentUser = useAuthState();
    const { t } = useTranslation();
    const { refreshCredits, creditsInfo } = useCreditsContext();
    const lieuxPanel = useRef(null);
    const adminImpersonatingRecruteurId = history.location?.state?.adminImpersonatingRecruteurId;
    const documentService = new DocumentService();
    const entrepriseService = new EntrepriseService();
    const [dialogConnection, setDialogConnection] = useState(false);
    const [dialogFreemiumInfo, setDialogFreemiumInfo] = useState(false);
    const [showMissingCreditsPopup, setShowMissingCreditsPopup] = useState(false);

    const openVueCandidat = () => {
        const pathname = `/Candidat/${props.etudiant.urlCode}/${props.etudiant.prenom}-` + props.etudiant.nom.charAt(0);
        RoleHelper.windowOpenadminImpersonatingRecruteurIdStorage(pathname, adminImpersonatingRecruteurId);
    }

    const renderTypeRecherche = () => {
        let hasAlternanceTag = false;
        let hasEmploiTag = false;
        let hasStageTag = false;
        props.etudiant?.paireContrats?.forEach(e => {
            if (e.code == enumPaireContrat.ALTCA || e.code == enumPaireContrat.ALTCP) {
                hasAlternanceTag = true
            }
            if (e.code == enumPaireContrat.CDD || e.code == enumPaireContrat.CDI || e.code == enumPaireContrat.CDIINTERIM || e.code == enumPaireContrat.MISINTERIM || e.code == enumPaireContrat.PROCOM || e.code == enumPaireContrat.PROLIB) {
                hasEmploiTag = true
            }
            if (e.code == enumPaireContrat.STA) {
                hasStageTag = true
            }
        });

        return (
            <div className="ct-tags-section">
                {hasAlternanceTag && <DipTag className={"ct-diptag dip-tag-fs-sm dip-fw-600 p-mb-2"} hasLetterSpacing label={t('offers.alternance').toUpperCase()} />}
                {hasStageTag && <DipTag className={"ct-diptag dip-tag-fs-sm dip-fw-600 p-mb-2"} hasLetterSpacing label={t('offers.traineeship').toUpperCase()} />}
                {hasEmploiTag && <DipTag className={"ct-diptag dip-tag-fs-sm dip-fw-600 p-mb-2"} hasLetterSpacing label={t('offers.job').toUpperCase()} />}
            </div>)
    }

    const renderMobilite = () => {
        let _countLieux = 0;
        let _currentLocation;
        let _locations = [];
        if (props.etudiant.mobiliteInternationale) {
            _countLieux = _countLieux + 1;
            _currentLocation = t('geography.international_except_france')
            _locations.push(_currentLocation);
        }
        if (props.etudiant.mobiliteFrancaise) {
            _countLieux = _countLieux + 1
            _currentLocation = t('geography.france');
            _locations.push(_currentLocation);
        }
        props.etudiant.mobiliteRegion?.forEach(r => {
            _countLieux = _countLieux + 1
            _currentLocation = r.libelle
            _locations.push(_currentLocation);
        });
        props.etudiant.mobiliteDepartement?.forEach(d => {
            _countLieux = _countLieux + 1
            _currentLocation = d.code + " - " + d.libelle
            _locations.push(_currentLocation);
        });
        if (_countLieux > 1) {
            return (
                <>
                    <Button type="button" className="location-button" icon="pi pi-eye" label={`${_countLieux} lieux`} onClick={(e) => lieuxPanel.current.toggle(e)} />
                    <OverlayPanel className="location-panel" ref={lieuxPanel}>
                        {_locations.map((l, indexL) => (
                            <Fragment key={`${l}~${indexL}`}>
                                <div>{l}</div>
                            </Fragment>
                        ))}
                    </OverlayPanel>
                </>
            );
        }
        else if (_countLieux == 1) {
            return <span>{_currentLocation}</span>;
        }
        else return <span>{t('general.not_specified')}</span>;
    }

    const showCVPdf = () => {
        handleDocumentDownload({
            currentUser,
            setDialogConnection,
            setDialogFreemiumInfo,
            displayFakeInformation: props.displayFakeInformation,
            entrepriseId: props.entrepriseId,
            etudiantId: props.etudiant.id,
            creditActionEnum: props.creditActionEnumCV || enumCreditableShareEntreprise.CVPAGECANDIDAT,
            documentId: props.etudiant.fichierCvPdf.id,
            documentName: props.etudiant.fichierCvPdf.name,
            documentService,
            entrepriseService,
            toast: props.toast,
            t,
            onMissingCredits: () => setShowMissingCreditsPopup(true),
            onCreditUpdate: () => refreshCredits(),
            openMethod: "tab"
        });
    };

    const showPortfolio = () => {
        handleDocumentDownload({
            currentUser,
            setDialogConnection,
            setDialogFreemiumInfo,
            displayFakeInformation: props.displayFakeInformation,
            entrepriseId: props.entrepriseId,
            etudiantId: props.etudiant.id,
            creditActionEnum: props.creditActionEnumPortfolio || enumCreditableShareEntreprise.PORTFOLIOPAGECANDIDAT,
            documentId: props.etudiant.fichierPortfolio.id,
            documentName: props.etudiant.fichierPortfolio.name,
            documentService,
            entrepriseService,
            toast: props.toast,
            t,
            onMissingCredits: () => setShowMissingCreditsPopup(true),
            onCreditUpdate: () => refreshCredits(),
            openMethod: "tab"
        });
    };

    return (
        <div className={props.className}>
            <UpgradeSubscriptionDialog dialogVisible={dialogFreemiumInfo} setDialogVisible={setDialogFreemiumInfo} />
            <MissingCreditsDialog 
                showMissingCreditsPopup={showMissingCreditsPopup} 
                setShowMissingCreditsPopup={setShowMissingCreditsPopup} 
                nextCreditRenewalDate={creditsInfo.nextRechargeDate}
            />
            <div className="ct-oe-item-container">
                <div className="p-shadow-4 ct-box-container">
                    {/* Header avec photo et like */}
                    <div className="ct-header">
                        <div className="ct-profile-image">
                            {props.etudiant.fichierPhoto ? (
                                <DisplayProfileImage imageId={props.etudiant.fichierPhoto?.id} alt={t('meta-img.alt-student-picture') + " " + props.etudiant?.prenom + " " + props.etudiant?.nom} />
                            ) : (
                                (() => {
                                    // Build initials from first name and last name first letter
                                    const first = props.etudiant?.prenom ? props.etudiant.prenom.charAt(0) : "";
                                    const last = props.etudiant?.nom ? props.etudiant.nom.charAt(0) : "";
                                    const initials = (first + last).toUpperCase();
                                    return <Avatar label={initials} />;
                                })()
                            )}
                        </div>
                        <div className="ct-like-container">
                            <div className="dip-flex-row">
                                {RoleHelper.isEntreprise(currentUser) || adminImpersonatingRecruteurId && <div className="p-mr-2"><ProjetOverlayPanel etudiantId={props.etudiant.id} /></div>}
                                <LikeEtudiant etudiant={props.etudiant} toast={props.toast} />
                            </div>
                        </div>
                    </div>

                    {/* Contenu principal */}
                    <div className="ct-content">
                        <div className="ct-titre">{props.etudiant.prenom} {props.etudiant.nom.charAt(0).toUpperCase()}</div>
                        
                        {renderTypeRecherche()}
                        
                        <div className="ct-info-item ct-niveau-etude">
                            <IoSchoolOutline />
                            <span>{props.etudiant.niveauEtude || t('general.not_specified')}</span>
                        </div>
                        
                        <div className="ct-info-item ct-disponibilite">
                            <IoCalendarOutline />
                            <span>
                                {props.etudiant.rechercheActiveCalendrier 
                                    ? t('company.available_until') + ' ' + Helper.dateTimeToLocaleDateTime(props.etudiant.rechercheActiveCalendrier)
                                    : t('general.not_specified')
                                }
                            </span>
                        </div>
                        
                        <div className="ct-info-item ct-mobilite-section">
                            <IoCarOutline />
                            <div className="ct-mobilite-content">
                                {renderMobilite()}
                            </div>
                        </div>
                    </div>

                    {/* Footer avec boutons */}
                    <div className="ct-footer">
                        <div className="ct-documents-section">
                            {props.etudiant.fichierCvPdf?.dateValidation && (
                                <Button label="CV" icon="pi pi-file" className="ct-doc-button p-mr-2" onClick={showCVPdf} />
                            )}
                            {props.etudiant.fichierPortfolio?.dateValidation && (
                                <Button label="Portfolio" icon="pi pi-briefcase" className="ct-doc-button" onClick={showPortfolio} />
                            )}
                        </div>
                        <div className="ct-arrow-button-container">
                            <Button id="see-formation" className="ct-button-see-formation" onClick={openVueCandidat}>
                                <i className="pi pi-arrow-right" />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}